import React from 'react';

import { Text, useStyleConfig, TextProps } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import iconSizes from 'theme/variants/Icon';

type IconPrefix = 'fas' | 'fab' | 'far' | 'fal' | 'fad';

interface IconProps extends TextProps{
  name?: any,
  family?:IconPrefix,
  size?: keyof typeof iconSizes
}

export default function Icon({
  name,
  family = 'fas',
  size = 'sm',
  ...rest
}: IconProps) {
  const styles = useStyleConfig('Icon', { variant: size });
  return (
    <Text
      sx={styles}
      display="flex"
      {...rest}>
      <FontAwesomeIcon icon={[family, name]} />
    </Text>
  );
}
